// @flow

import { combineReducers } from 'redux';

import details from './details/details.reducer';
import packageUpsell from './package/package.reducer';
import priceAndPayment from './price-and-payment/priceAndPayment.reducer';
import transport from './transport/transport.reducer';
import modals from './modals/modals.reducer';
import stayFormalities from './stay-formalities/stayFormalities.reducer';

export default combineReducers({
  details,
  packageUpsell,
  priceAndPayment,
  transport,
  modals,
  stayFormalities,
});
